<template>
    <div class="line-drawing-wrap">
        <Twinkly class="T" />
        <Inspiring class="I" />
        <Newborn class="N" />
        <Adventurous class="A" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Inspiring from './Inspiring.vue'
import Twinkly from './Twinkly.vue'
import Newborn from './Newborn.vue'
import Adventurous from './Adventurous.vue'

export default {
    name: 'Name',
    components: {
        Twinkly,
        Inspiring,
        Newborn,
        Adventurous
    },
    data() {
        return {
            timeline: null,
        }
    },
    mounted() {
        this.drawText()
    },
    computed: {
        ...mapState(['dayMode'])
    },
    watch: {
        dayMode() {
            this.drawText()
        },
    },
    methods: {
        timelineAnimate() {
            this.timeline = this.$anime.timeline({
                easing: 'easeInOutCubic',
                duration: 1200,
                delay: function(el, i) { return i * 250 },
                direction: 'alternate',
                loop: true
            })

            this.timeline
            .add({
                targets: '.T path',
                strokeDashoffset: [this.$anime.setDashoffset, 0],
            })
            .add({
                targets: '.I path',
                strokeDashoffset: [this.$anime.setDashoffset, 0],
            })
            .add({
                targets: '.N path',
                strokeDashoffset: [this.$anime.setDashoffset, 0],
            })
            .add({
                targets: '.A path',
                strokeDashoffset: [this.$anime.setDashoffset, 0],
            })
        },
        drawText() {
            if(this.timeline) { 
                this.timeline.restart()
                this.timeline.pause()
            }

            this.timelineAnimate()
        },
    },
}
</script>

<style scoped>
.line-drawing-wrap {
    display: flex;
    flex-direction: column;
}

.I, .A {
    align-self: flex-end;
}

.T, .I,.N, .A {
        transform: scale(0.9);
    }

svg {
    margin-bottom: 10px;
}

@media screen and (max-width: 650px) {
    .T, .I,.N, .A {
        transform: scale(0.5);
        margin-top: -30px;
    }
}

@media screen and (max-width: 530px) {
    .T, .I,.N, .A {
        transform: scale(0.3);
        margin-top: -30px;
    }
}
</style>